export default __webpack_public_path__ + "static/media/480_dummy2016-friseur01-mobile-de.8b88642f.png";